import { z } from 'zod';

export const DataSchema = z.object({
    monday: z.number().catch(0),
    tuesday: z.number().catch(0),
    wednesday: z.number().catch(0),
    thursday: z.number().catch(0),
    friday: z.number().catch(0),
    saturday: z.number().catch(0),
    sunday: z.number().catch(0),
});
export type DataType = z.infer<typeof DataSchema>;
